(function () {
  function productRoot(from) {
    return from.closest('product-info') || from.closest('.ff-pdp-page') || document;
  }

  function variantList(picker) {
    const raw = picker && picker.querySelector('[data-ff-variants]');
    if (!raw) return [];
    try { return JSON.parse(raw.textContent); } catch (err) { return []; }
  }

  function optionGroups(picker) {
    return Array.from(picker.querySelectorAll('fieldset'));
  }

  function selectedOptions(picker) {
    return optionGroups(picker).map((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    });
  }

  function findVariant(list, options) {
    return list.find((variant) => variant.options.length === options.length && variant.options.every((value, i) => value === options[i]));
  }

  function paintOptionPrices(picker) {
    const list = variantList(picker);
    if (list.length < 2 || optionGroups(picker).length < 2) return;
    const selected = selectedOptions(picker);
    optionGroups(picker).forEach((group, index) => {
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        const want = selected.slice();
        want[index] = input.value;
        const match = findVariant(list, want);
        if (!match) return;
        input.dataset.ffVariantId = String(match.id);
        input.dataset.ffPrice = match.price_formatted;
        input.dataset.ffPriceCents = String(match.price);
        const price = input.id && group.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"] .ff-pdp__opt-price');
        if (price) price.textContent = match.price_formatted;
      });
    });
  }

  function syncFromInput(input) {
    if (!input) return;
    const root = productRoot(input);
    const picker = input.closest('variant-selects');
    if (picker) paintOptionPrices(picker);
    const formatted = (input.dataset.ffPrice || '').trim();
    const variantId = input.dataset.ffVariantId;
    const labels = picker
      ? Array.from(picker.querySelectorAll('input[type="radio"]:checked'))
          .map((el) => (el.value || '').trim())
          .filter(Boolean)
      : [];
    const choice = labels.join(' · ') || input.value || '';

    if (formatted) {
      root.querySelectorAll('.price__regular .price-item--regular').forEach((el) => {
        el.classList.remove('price-item--from');
        el.textContent = formatted;
      });
    }

    const chosen = root.querySelector('[data-ff-chosen]');
    if (chosen && choice) chosen.textContent = choice;

    document.querySelectorAll('[data-ff-dock-price]').forEach((el) => {
      if (formatted) el.textContent = formatted;
    });
    document.querySelectorAll('[data-ff-dock-var]').forEach((el) => {
      if (choice) el.textContent = choice;
    });

    const orderForm = root.querySelector('form[data-type="add-to-cart-form"]');
    const panel = orderForm && orderForm.querySelector('[data-ff-confirm]');
    if (panel && !panel.hidden) paintConfirm(orderForm);

    if (variantId) {
      root.querySelectorAll('input[name="id"]').forEach((el) => {
        el.value = variantId;
      });
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (err) {
        /* ignore */
      }
    }
  }

  function variantKind(label) {
    const s = String(label || '').toLowerCase();
    if (/glas/.test(s) && !/displayreparatur \(apple|original/.test(s)) return 'glas';
    if (/nachbau|soft-oled|soft oled|in-cell/.test(s)) return 'nachbau';
    if (/refurb|aufbereitet/.test(s)) return 'refurb';
    if (/original|zertifiziert/.test(s)) return 'original';
    return '';
  }

  function radios(scope) {
    return Array.from((scope || document).querySelectorAll('.ff-pdp variant-selects input[type="radio"], variant-selects input[type="radio"]'));
  }

  function pickVariant(kind, scope) {
    const list = radios(scope);
    const match = list.find((el) => variantKind(el.value) === kind && !el.disabled);
    if (!match) return false;
    if (!match.checked) {
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncFromInput(match);
    document.querySelector('variant-selects, #varianten')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  function markGuide(scope) {
    const root = scope || document;
    const checked = radios(root).find((el) => el.checked);
    const kind = variantKind(checked && checked.value);
    root.querySelectorAll('[data-ff-var-pick]').forEach((card) => {
      const k = card.getAttribute('data-ff-var-pick');
      const has = radios(root).some((el) => variantKind(el.value) === k && !el.disabled);
      card.hidden = !has;
      card.classList.toggle('is-on', has && k === kind);
    });
  }

  function bindGuide(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-ff-var-pick]').forEach((card) => {
      if (card.dataset.ffVarBound === 'true') return;
      card.dataset.ffVarBound = 'true';
      const activate = () => pickVariant(card.getAttribute('data-ff-var-pick'), productRoot(card));
      card.addEventListener('click', activate);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      });
    });
    markGuide(scope);
  }

  function bindPicker(root) {
    const scope = root || document;
    scope.querySelectorAll('variant-selects').forEach((picker) => {
      if (picker.dataset.ffPriceBound === 'true') return;
      picker.dataset.ffPriceBound = 'true';
      paintOptionPrices(picker);
      picker.addEventListener('change', (event) => {
        const input = event.target;
        if (input && input.matches('input[type="radio"]')) {
          syncFromInput(input);
          markGuide(productRoot(input));
        }
      });
    });
  }

  function handoffValue(form) {
    const checked = form.querySelector('.ff-pdp__handoff input:checked');
    return checked ? checked.value : '';
  }

  function paintConfirm(form) {
    const panel = form.querySelector('[data-ff-confirm]');
    if (!panel) return;
    const root = productRoot(form);
    const picker = root.querySelector('variant-selects');
    const labels = picker
      ? Array.from(picker.querySelectorAll('input[type="radio"]:checked'))
          .map((el) => (el.value || '').trim())
          .filter(Boolean)
      : [];
    const choice = panel.querySelector('[data-ff-confirm-choice]');
    const price = panel.querySelector('[data-ff-confirm-price]');
    const way = panel.querySelector('[data-ff-confirm-way]');
    const bill = panel.querySelector('[data-ff-confirm-bill]');
    const pickup = panel.querySelector('[data-ff-confirm-pickup]');
    if (choice) choice.textContent = labels.join(' · ') || panel.dataset.ffTitle || '';
    if (price) {
      price.textContent = (root.querySelector('[id^="price-"] .price__regular .price-item--regular')?.textContent || '').trim();
    }
    const method = handoffValue(form);
    const sendHint = form.querySelector('[data-ff-send-hint]');
    if (sendHint) sendHint.hidden = method !== 'Einsenden';
    if (pickup) pickup.hidden = method !== 'Abholservice';
    if (way) {
      if (method === 'Einsenden') way.textContent = panel.dataset.ffMail || '';
      else if (method === 'Vorbeibringen') way.textContent = panel.dataset.ffDropoff || '';
      else if (method === 'Abholservice') way.textContent = panel.dataset.ffPickupNote || '';
      else way.textContent = '';
    }
    if (bill) {
      var billText = '';
      if (method === 'Einsenden') billText = panel.dataset.ffBillSend || '';
      else if (method === 'Abholservice') billText = panel.dataset.ffBillPickup || '';
      else billText = panel.dataset.ffBillVisit || '';
      bill.textContent = billText;
      bill.hidden = !billText;
    }
  }

  function openConfirm(form) {
    const panel = form.querySelector('[data-ff-confirm]');
    if (!panel) return;
    paintConfirm(form);
    panel.hidden = false;
    const buttons = form.querySelector('.product-form__buttons');
    if (buttons) buttons.hidden = true;
    const err = panel.querySelector('[data-ff-confirm-error]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const focus = handoffValue(form) === 'Abholservice'
      ? panel.querySelector('[data-ff-street]')
      : panel.querySelector('[data-ff-withdraw]');
    if (focus) focus.focus();
  }

  function confirmError(panel, message, focus) {
    const err = panel.querySelector('[data-ff-confirm-error]');
    if (err) {
      err.hidden = false;
      err.textContent = message;
    }
    if (focus) focus.focus();
  }

  function payConfirm(form) {
    const panel = form.querySelector('[data-ff-confirm]');
    if (!panel) return;
    const method = handoffValue(form);
    const pickupProp = form.querySelector('[data-ff-pickup-prop]');
    if (method === 'Abholservice') {
      const street = (panel.querySelector('[data-ff-street]')?.value || '').trim();
      const zip = (panel.querySelector('[data-ff-zip]')?.value || '').trim();
      const city = (panel.querySelector('[data-ff-city]')?.value || '').trim();
      if (!street || !zip || !city) {
        confirmError(panel, 'Bitte geben Sie die vollständige Abholadresse an.', panel.querySelector('[data-ff-street]'));
        return;
      }
      if (!/^\d{5}$/.test(zip)) {
        confirmError(panel, 'Bitte geben Sie eine fünfstellige Postleitzahl an.', panel.querySelector('[data-ff-zip]'));
        return;
      }
      if (pickupProp) {
        pickupProp.disabled = false;
        pickupProp.value = street + ', ' + zip + ' ' + city;
      }
    } else if (pickupProp) {
      pickupProp.value = '';
      pickupProp.disabled = true;
    }
    const box = panel.querySelector('[data-ff-withdraw]');
    if (!box || !box.checked) {
      confirmError(panel, 'Bitte bestätigen Sie, dass wir vor Ablauf der Widerrufsfrist mit der Reparatur beginnen sollen.', box);
      return;
    }
    const stamp = form.querySelector('[data-ff-withdraw-prop]');
    if (stamp) {
      stamp.disabled = false;
      stamp.value = 'Ja – ' + new Date().toISOString();
    }
    const err = panel.querySelector('[data-ff-confirm-error]');
    if (err) err.hidden = true;
    form.dataset.ffCheckout = '1';
    const pay = form.querySelector('[data-ff-pay]');
    if (pay) pay.disabled = true;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  function bindConfirm(root) {
    const scope = root || document;
    scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      if (!form.querySelector('[data-ff-confirm]') || form.dataset.ffConfirmBound === 'true') return;
      form.dataset.ffConfirmBound = 'true';
      form.addEventListener('submit', (event) => {
        if (form.dataset.ffCheckout === '1') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openConfirm(form);
      }, true);
      form.addEventListener('change', (event) => {
        if (event.target && event.target.closest('.ff-pdp__handoff')) paintConfirm(form);
      });
      paintConfirm(form);
      const back = form.querySelector('[data-ff-confirm-back]');
      if (back) {
        back.addEventListener('click', () => {
          const panel = form.querySelector('[data-ff-confirm]');
          if (panel) panel.hidden = true;
          const buttons = form.querySelector('.product-form__buttons');
          if (buttons) buttons.hidden = false;
          form.dataset.ffCheckout = '';
        });
      }
      const pay = form.querySelector('[data-ff-pay]');
      if (pay) pay.addEventListener('click', () => payConfirm(form));
    });
  }

  function bindDock() {
    const dock = document.querySelector('[data-ff-dock]');
    const submit = document.querySelector('.ff-pdp .product-form__submit');
    if (!dock || !submit || !('IntersectionObserver' in window)) return;

    const cta = dock.querySelector('[data-ff-dock-cta]');
    if (cta) {
      cta.addEventListener('click', () => {
        if (submit.disabled) {
          document.getElementById('varianten')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        submit.click();
      });
    }

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((entry) => entry.isIntersecting);
        dock.hidden = visible;
      },
      { threshold: 0.2 }
    );
    io.observe(submit);
  }

  function init(root) {
    bindPicker(root);
    bindGuide(root);
    bindConfirm(root);
    if (!root) bindDock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
